import React from 'react'

import '../../assets/css/bootstrap.min.css'
import '../../assets/css/all.min.css'
import '../../assets/css/swiper-bundle.min.css'
import '../../assets/css/magnific-popup.css'
import '../../assets/css/animate.css'
import '../../assets/css/nice-select.css'
import '../../assets/css/style.css'

import { Link } from 'react-router-dom';
import tutorialVideo from '../../assets/video/Aranyasetu_tutorial_video.mp4';
import mobiletutorialvideo from '../../assets/video/Aranyasetu_mobile_tutorial.mp4';
import tutorialThumbnail from '../../assets/images/tutorial_thumbnail.png';
import mobiletutorialThumbnail from '../../assets/images/mobile_tutorial_thumbnail.png';

const Services = () => {

  return (
    <div>
      <section className="page-service sub-bg pt-20">
        <div className="container">

          <div className="section-header mb-5">
            <h2 className="wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".4s">How It Works ?</h2>
            <p className="wow fadeInUp " data-wow-duration="1.6s" data-wow-delay=".6s">
              Below are 3 easy steps to participate in this movement</p>
          </div>

          <div className="row g-4 pb-20">
            <div
              className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 wow fadeInDown"
              data-wow-duration="1.2s"
              data-wow-delay=".2s"
            >
              <div className="work__item">
                <div className="work__item-icon">
                  <img src="/images/icon/work1.svg" alt="icon" />
                  <span className="gradient-number">01</span>
                </div>
                <h3><Link to="/login" className="text-white">Login To Your Account</Link></h3>
                <div className="work__item-leaf">
                  <img src="/images/shape/work-leaf.png" alt="work-leaf" />
                </div>
              </div>
            </div>
            <div
              className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 wow fadeInDown"
              data-wow-duration="1.4s"
              data-wow-delay=".4s"
            >
              <div className="work__item">
                <div className="work__item-icon">
                  <img src="/images/icon/work2.svg" alt="icon" />
                  <span>02</span>
                </div>
                <h3><Link to="/upload" className="text-white">Capture Your Tree Photo</Link></h3>
                <div className="work__item-leaf">
                  <img src="/images/shape/work-leaf.png" alt="work-leaf" />
                </div>
              </div>
            </div>
            <div
              className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 wow fadeInDown"
              data-wow-duration="1.6s"
              data-wow-delay=".6s"
            >
              <div className="work__item">
                <div className="work__item-icon">
                  <img src="/images/icon/work3.svg" alt="icon" />
                  <span>03</span>
                </div>
                <h3><Link to="/trees" className="text-white">Submit & Share Your Photo</Link></h3>
                <div className="work__item-leaf">
                  <img src="/images/shape/work-leaf.png" alt="work-leaf" />
                </div>
              </div>
            </div>
          </div>

          <div className="row g-4 align-items-center">
            <div className="col-xl-8">
              <div className="page-service__right-item">

                <div className="row g-4">
                  <div className="col-sm-12 wow fadeInLeft" data-wow-duration="1.3s" data-wow-delay=".3s">
                    <ul>

                      <li><i className="fa-solid  me-2 primary-color fa-gear"></i>Participants may only take photographs of newly planted trees or saplings.</li>
                      <li><i className="fa-solid me-2 primary-color fa-gear"></i>Long-lasting tree varieties are preferred and must be planted directly in the ground, not in pots.</li>
                      <li><i className="fa-solid  me-2 primary-color fa-gear"></i>Selfies or photos with human faces will not be verified.</li>
                      <li><i className="fa-solid  me-2 primary-color fa-gear"></i>Participants must grant geolocation and camera permissions to take photos.</li>
                      <li><i className="fa-solid me-2 primary-color fa-gear"></i>Your location and camera are accessed only when you capture a plant photo.</li>
                      <li><i className="fa-solid me-2 primary-color fa-gear"></i>All uploaded photos will be checked for authenticity.</li>
                      <li><i className="fa-solid   me-2 primary-color fa-gear"></i>Inappropriate images will be deleted.</li>
                      <li><i className="fa-solid   me-2 primary-color fa-gear"></i>Any form of spamming will result in account suspension.</li>

                    </ul>
                  </div>

                </div>
                <div className="section-header mb-5 mt-2">
                  <p className="wow fadeInUp " data-wow-duration="1.6s" data-wow-delay=".6s">
                    Please provide clear, accurate photos with geolocation information for more accurate
                    verification. Watch the tutorial video for more information.
                    <br /> 
                    
                    <Link
                      to="/upload"
                      className="btn-one wow fadeInUp mt-2"
                      data-wow-duration="1.5s"
                      data-wow-delay=".5s"
                    >
                      <span>Register your Tree</span>
                      <i className="fa-solid fa-angles-right"></i>
                    </Link>
                  </p>
                </div>

              </div>
            </div>
            <div className="col-xl-4">
              {/* <div className="image position-relative">
                <div className="container-youtube">
                   <iframe title="ytvideo" className="responsive-iframe" src="https://www.youtube.com/embed/AkbGz3CYvqE?&loop=1&autoplay=0&controls=0"></iframe> 
                 <video
                    className="responsive-iframe"
                    src={tutorialVideo}
                    poster={tutorialThumbnail}
                    controls
                    loop
                    playsInline
                  >
                    Your browser does not support this video.
                  </video>
                </div>
              </div> */}
            <div className="image position-relative pb-4">
  <div className="container-youtube" style={{ maxWidth: '80%', margin: '0 auto' }}>
    <video
      className="responsive-iframe"
      src={tutorialVideo}
      poster={tutorialThumbnail}
      controls
      loop
      playsInline
    >
      Your browser does not support this video.
    </video>
  </div>
  <div className="container-youtube" style={{ maxWidth: '80%', margin: '0 auto' }}>
    <video
      className="responsive-iframe"
      src={mobiletutorialvideo}
            poster={mobiletutorialThumbnail}
      controls
      loop
      playsInline
    >
      Your browser does not support this video.
    </video>
  </div>
</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
};

export default Services